import { SelectedProject } from '../../../../../generated';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';
import { readEntityCacheFragmentById } from '../../utils/typePolicyUtils';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      selectedProjects: {
        read: (_existing, { cache, args }) =>
          args.projectIds.map((id: any) =>
            readEntityCacheFragmentById({
              cache,
              fragment: SelectedProject,
              fragmentName: 'SelectedProject',
              selector: {
                id,
                __typename: 'Project',
              },
            })
          ),
      },
    },
  },
};
